import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { StyledSelectIcon } from './select-field.styles';
import arrow from '@images/arrow-up.svg';
import close from '@images/close.svg';
/**
 * Select icon.
 *
 * @author Mikhail Siutsou
 * @function selectIcon
 * @category helpers
 * @param {{ className: string }} props icon props.
 * @return {FC} icon component.
 */

import { jsx as _jsx } from "react/jsx-runtime";

var SelectIcon = function SelectIcon(props) {
  return /*#__PURE__*/_jsx(StyledSelectIcon, _objectSpread({
    src: arrow,
    width: 24,
    height: 24
  }, props));
};
/**
 * Close icon.
 *
 * @author Mikhail Siutsou
 * @function selectIcon
 * @category helpers
 * @param {{ className: string }} props icon props.
 * @return {FC} icon component.
 */


var CloseIcon = function CloseIcon(_ref) {
  var handleClick = _ref.handleClick,
      mouseDown = _ref.mouseDown;
  return /*#__PURE__*/_jsx(StyledSelectIcon, {
    isClose: true,
    src: close,
    width: 20,
    height: 20,
    onClick: handleClick,
    onMouseDown: mouseDown
  });
};

export { CloseIcon, SelectIcon };